import { render } from "./RegisterUserData.vue?vue&type=template&id=61e04eb3&scoped=true"
import script from "./RegisterUserData.vue?vue&type=script&lang=js"
export * from "./RegisterUserData.vue?vue&type=script&lang=js"

import "./RegisterUserData.vue?vue&type=style&index=0&id=61e04eb3&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e04eb3"]])

export default __exports__